import * as R from 'ramda';

import getFilters from '../../selectors/getSelectedFilters';
import getUseRightsholderAttribution from '../../utils/getUseRightsholderAttribution';
import { isFailedToFetchError } from '../../utils/requestErrorHandlers';
import fetchMediaValueReportCached, {
    isMediaValueReportRequestError,
} from './utils/fetchMediaValueReportCached';
import hasFiltersChanged from './utils/hasFiltersChanged';

const getTopPlatformTotal = store => async state => {
    const userClientId = state.user.selectedUserClientId;
    const clientId = state.user.selectedClientId;
    const filters = state.clients[userClientId].filters;
    const client = state.user.clientsById[clientId];
    const useRightsholderAttribution = getUseRightsholderAttribution(
        client,
        clientId,
    );

    // Sets Cards as loading
    const loadingState = R.pipe(
        R.assocPath(
            [
                'clients',
                userClientId,
                'home',
                'topPlatform',
                'total',
                'isLoading',
            ],
            true,
        ),
        R.assocPath(
            [
                'clients',
                userClientId,
                'home',
                'topPlatform',
                'total',
                'hasError',
            ],
            false,
        ),
    )(state);

    store.setState(loadingState);

    const changesId = filters.changesId;
    const globFilters = getFilters(filters);

    // Get list of top 10 platforms with their values
    const platformsQuery = {
        ...globFilters,
        groupBy: ['socialPlatform'],
        orderBy: ['sponsorMediaValue-desc'],
        displayColumns: ['sponsorMediaValue'],
        includeTextTypeExposures: true,
        limit: 10,
        ...(useRightsholderAttribution
            ? { useRightsholderAttribution: true }
            : {}),
    };

    let result;

    try {
        result = await fetchMediaValueReportCached(platformsQuery);
    } catch (error) {
        if (
            !isFailedToFetchError(error) &&
            !isMediaValueReportRequestError(error)
        ) {
            throw error;
        }

        if (hasFiltersChanged(store, userClientId, changesId)) return;

        store.setState(
            R.pipe(
                R.assocPath(
                    [
                        'clients',
                        userClientId,
                        'home',
                        'topPlatform',
                        'total',
                        'isLoading',
                    ],
                    false,
                ),
                R.assocPath(
                    [
                        'clients',
                        userClientId,
                        'home',
                        'topPlatform',
                        'total',
                        'hasError',
                    ],
                    true,
                ),
            )(store.getState()),
            true,
        );
        return;
    }

    const values = Array.isArray(result?.values) ? result.values : [];

    const list = values.map(v => ({
        id: v.socialPlatformId,
        name: v.socialPlatformName,
        value: v.sponsorMediaValue,
    }));

    if (hasFiltersChanged(store, userClientId, changesId)) return;

    store.setState(
        R.assocPath(
            ['clients', userClientId, 'home', 'topPlatform', 'total'],
            {
                isLoading: false,
                hasError: false,
                list,
                changesId,
            },
            store.getState(),
        ),
        true,
    );
};

export default getTopPlatformTotal;
